// utils/meetingUtils.js

export const DEFAULT_BIO = "Apasionado del motor formando parte de Driving Your Dream";
export const BIO_MAX_LENGTH = 150;

export const truncateText = (text, max) =>
  text && text.length > max ? text.slice(0, max).trim() + '…' : text;

/**
 * Imágenes que se han ido usando como portada por defecto. Lo creado antes las
 * lleva guardadas en base de datos, así que las tratamos como "sin imagen"
 * para que salga en su lugar la portada que genera el propio front.
 */
const DEFAULT_IMAGES = [
  "drivingyourdream-club-1.png",        // portada del club (el enlace ya no existe)
  "275378650-isolated-red-sports-car",  // coche rojo de stock
];

/** true solo si la imagen es una que haya subido el usuario. */
export const hasCustomImage = (url) =>
  Boolean(url) && !DEFAULT_IMAGES.some((fragment) => url.includes(fragment));

export const getValidUrl = (url) => {
  if (!url) return null;
  return url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
};

export async function getUserName(userId) {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/users/${userId}`);
    const data = await res.json();
    return data.name + " " + data.surname || "Desconocido";
  } catch (err) {
    console.error('Error cargando usuario:', err);
  }

}

const generarInvitacion = async (invitationCode) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/invitation/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: invitationCode
      }),
    });
    const data = await response.json();
    if (!response.ok) {
      alert("Error al generar la invitación: " + data.message);
    }
  } catch (error) {
    console.error("Error al generar la invitación:", error);
    alert("Error al generar la invitación. Por favor, inténtalo de nuevo más tarde.");
  }
};

export { generarInvitacion };

/* ============================================================
   IMÁGENES
   ============================================================ */

/** Tamaño máximo de una imagen subida, en MB. */
export const MAX_IMAGE_MB = 5;

/** Imágenes que admite la galería de un proyecto (el backend recorta igual). */
export const MAX_GALLERY_IMAGES = 12;

/**
 * Lee un archivo como data URI (base64).
 *
 * Las imágenes no se suben desde el navegador: viajan en base64 dentro del
 * JSON del formulario y es el backend quien las manda a imgbb y guarda la URL.
 */
export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

/* ============================================================
   SESIÓN
   ============================================================ */

/** Datos de sesión que deja el login en localStorage. */
const SESSION_KEYS = [
  'token', 'userId', 'isAdmin', 'name', 'email',
  'profileName', 'profileSurname', 'profileImage',
];

/** Momento en que caduca el JWT, en milisegundos. */
const getTokenExpiry = (token) => {
  try {
    // El payload va en base64url, que no es exactamente lo que espera atob
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(payload));
    // Un token sin caducidad no lo emitimos nosotros, pero que decida el backend
    return exp ? exp * 1000 : Infinity;
  } catch {
    return 0; // Ilegible: no es un token válido, lo damos por caducado
  }
};

/**
 * true si no hay token o si ya ha caducado (duran 24 h).
 *
 * Sin esta comprobación la app da por buena cualquier cadena guardada y deja
 * navegar con una sesión muerta: todo parece ir bien hasta que una llamada
 * autenticada responde "Token inválido o expirado" al guardar.
 */
export const isSessionExpired = (token = localStorage.getItem('token')) => {
  if (!token) return true;
  return getTokenExpiry(token) <= Date.now();
};

/** Borra los datos de sesión, sin tocar la navegación. */
export const clearSession = () => SESSION_KEYS.forEach((key) => localStorage.removeItem(key));

/** Cierra la sesión y vuelve al login avisando de por qué. */
export const endSession = (message = 'Tu sesión ha caducado. Vuelve a iniciar sesión.') => {
  clearSession();
  alert(message);
  window.location.href = '/';
};
